import { ApiEpPost, IApiEpPageconfig, IApiEpPostListReq } from "@smp/api";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import { useQuery } from "react-query";

import { useDateCurrent } from "@/hooks/use_date_current";

export const PostLast = ({
  lookFor,
  pageconfig,
}: {
  lookFor: "first" | "last";
  pageconfig: IApiEpPageconfig;
}) => {
  const { dateCurrent } = useDateCurrent();

  const reqPost: IApiEpPostListReq = {
    query: {
      all_organization_contexts: true,
      archived: false,
      error__isnull: true,
      external_id: "",
      ordering: lookFor === "first" ? "scheduled_for" : "-scheduled_for",
      page_config__in: [pageconfig.id],
      scheduled_for__gte: dateCurrent.toISOString(),
    },
  };

  const { data } = useQuery(["ep.post", reqPost], () =>
    ApiEpPost.list(reqPost),
  );

  if (!data) return null;

  return (
    <>
      {data.results[0]?.scheduled_for &&
        format(parseISO(data.results[0]?.scheduled_for), "d MMMM yyyy")}
    </>
  );
};
